import Image from "next/image";

import styles from "./AffiliateBlock.module.scss";

export default function AffiliateBlock({ affiliate }) {
  const {
    name,
    category,
    logo,
    Text,
    url,
    link_title,
    anchor_text,
    target,
    rel_nofollow,
    rel_sponsored,
  } = affiliate;

  return (
    <article className={`${styles.container}`}>
      <a
        href={url}
        target={target}
        title={link_title}
        rel={`noopener ${rel_nofollow ? "nofollow" : ""} ${
          rel_sponsored ? "sponsored" : ""
        }`}
        className={`${styles.linkWrapper}`}
      >
        <div className={`${styles.content}`}>
          <span className={`${styles.diagonalBanner}`}>Travel Tool</span>
          {logo && (
            <div className={`${styles.imageLink}`}>
              <div className={`${styles.imageWrapper}`}>
                <Image
                  src={logo.url}
                  alt={`${name} logo`}
                  fill
                  // objectFit="contain"
                />
              </div>
            </div>
          )}
          <div className={`${styles.textContainer}`}>
            <span className={`${styles.titleContainer}`}>
              <h3 className={`${styles.titleText}`}>{anchor_text}</h3>
              {/* <Tag>Affiliate</Tag> */}
            </span>

            {Text && <p className={`${styles.text}`}>{Text}</p>}
          </div>
        </div>
      </a>
    </article>
  );
}
